// ============================================================
//  Lizenzmodell je System (Bauauftrag AP1).
//
//  Kernsatz: Es ist KEIN Entweder-oder. Ein System kann FUE für
//  seine Dialognutzer tragen UND zusätzlich eine Engine-Metrik für
//  sein Volumen. Deshalb vier Kategorien statt eines Ja/Nein.
//
//  A  fue            klassisches S/4HANA — nur FUE
//  B  fue+engine     S/4HANA mit lizenzpflichtigem Advanced-Modul:
//                    FUE für Nutzer PLUS Volumenmetrik obendrauf
//  C  eigene-metrik  eigene Metrik STATT FUE (GTS, HCM)
//  D  keine          gar keine eigene Lizenz (Fiori-Frontend, HANA Cockpit)
//
//  Belegt (Gespräche mit Arvato): GSP = GTS-Produktivsystem.
//  Recherchiert: EWM/TM Basic sind im S/4HANA-Kern enthalten, nur
//  Advanced ist zusätzlich lizenzpflichtig. HCM läuft unter Private
//  Cloud auf einer Employee-Metrik. Siehe SYSTEME_und_Lizenzmetriken.md.
// ============================================================

export type LicenseModel = "fue" | "fue+engine" | "eigene-metrik" | "keine";

export type LicenseCategory = "A" | "B" | "C" | "D";

export const MODEL_CATEGORY: Record<LicenseModel, LicenseCategory> = {
  fue: "A",
  "fue+engine": "B",
  "eigene-metrik": "C",
  keine: "D",
};

export const MODEL_LABEL: Record<LicenseModel, string> = {
  fue: "FUE",
  "fue+engine": "FUE + Engine",
  "eigene-metrik": "eigene Metrik",
  keine: "keine eigene Lizenz",
};

/** Ein Satz, der auf der Karte steht — warum zählt dieses System so? */
export const MODEL_EXPLAIN: Record<LicenseModel, string> = {
  fue: "Klassisches S/4HANA-System — die Berechtigungen der Nutzer bestimmen den FUE-Bedarf.",
  "fue+engine":
    "S/4HANA-System mit lizenzpflichtigem Advanced-Modul: die Nutzer zählen als FUE, das Volumen zusätzlich über eine eigene Engine-Metrik.",
  "eigene-metrik":
    "Nicht FUE-relevant — dieses System wird über eine eigene Lizenzmetrik abgerechnet, nicht über Berechtigungsklassen.",
  keine:
    "Trägt keine eigene Lizenz — Bestandteil der Plattform, erscheint deshalb ohne eigenen Lizenzwert.",
};

/** Eine Engine-/Sondermetrik. `wert === null` heißt: noch nicht bekannt — nicht geraten. */
export interface EngineLicense {
  /** Produktname, wie er im Vertrag stünde. */
  name: string;
  /** Bezugsgröße — was gezählt wird. */
  einheit: string;
  /** Vertraglich vereinbarter Wert; null = offen. */
  wert: number | null;
  /** Woher der Wert stammt. `offen` = muss aus Arvatos Vertrag kommen. */
  quelle: "vertrag" | "offen";
  /** Belegte Herkunft der Metrik-Aussage (für den Nachweis in der App). */
  herkunft: string;
}

export interface SystemLicensing {
  sid: string;
  model: LicenseModel;
  /** Nur bei Kategorie B und C belegt. */
  engine?: EngineLicense;
  /** Warum dieses System so eingestuft ist — systemindividuell. */
  note: string;
  /** true = die Einstufung ist belegt, false = Annahme bis zum Gegenbeweis. */
  belegt: boolean;
}

/** Trägt dieses Lizenzmodell FUE bei? Nur A und B. */
export function countsFue(model: LicenseModel): boolean {
  return model === "fue" || model === "fue+engine";
}

/** Trägt dieses Lizenzmodell eine eigene Volumen-/Sondermetrik? Nur B und C. */
export function hasOwnMetric(model: LicenseModel): boolean {
  return model === "fue+engine" || model === "eigene-metrik";
}
